import React, { type ReactNode, useCallback } from 'react';
import messages from './messages';
import { type UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics } from '@atlassian/analytics-bridge';
import Link from '@atlaskit/link';
import { useIntl } from 'react-intl-next';

export type ContactSupportProps = {
	label: ReactNode;
};

const ContactSupport = ({ label }: ContactSupportProps) => {
	const { formatMessage } = useIntl();

	const handleClick = useCallback((_: React.MouseEvent, analyticsEvent: UIAnalyticsEvent) => {
		analyticsEvent.update({
			actionSubject: 'link',
		});
		fireUIAnalytics(analyticsEvent, 'contactSupportLink');
	}, []);

	return (
		<Link
			href="https://support.atlassian.com/contact/"
			target="_blank"
			rel="noopener"
			onClick={handleClick}
		>
			{label ?? formatMessage(messages.linkText)}
		</Link>
	);
};

export default ContactSupport;
